import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuthProvider } from '@/hooks/auth/useAuthProvider';
import { StoredCookies } from '@/interfaces/auth/cookies.enum';
import { AppRoutes } from '@/interfaces/routes/AppRoutes';
import { cookieService } from '@/services/cookie.service';

export default function SignOutRedirect() {
	const { handleSignOut } = useAuthProvider();

	useEffect(() => {
		// Clear any saved query parameters on sign out
		cookieService.remove(StoredCookies.REDIRECT_QUERY_PARAMS);
		handleSignOut();
	}, [handleSignOut]);

	return <Navigate to={AppRoutes.SignIn} />;
}
